export default __webpack_public_path__ + "static/media/catalog.d43a1662.svg";